/* =============================================================
   Kronura AI Chat Widget — Phase 1
   Vanilla JS, IIFE, inga externa bibliotek.
   Domänlogik styrs av backend — frontend detekterar
   bara hostname för att välja korrekt språk/snabbknappar.
============================================================= */
(function () {
  'use strict';

  // ── Config ──────────────────────────────────────────────────
  var apiBase = (window.kcApiUrl || '').replace(/\/$/, '');

  if (!apiBase || apiBase.indexOf('DIN-VERCEL') !== -1) {
    console.warn('[Kronura Chat] Sätt window.kcApiUrl i snippets/kronura-chat.liquid.');
    return;
  }

  var IS_COM = window.location.hostname.indexOf('kronura.com') !== -1;
  var TIMEOUT_MS = 12000;

  // ── i18n ────────────────────────────────────────────────────
  var SE = {
    welcome:      'Hej! Jag är Kronuras AI-assistent. Jag hjälper dig hitta rätt klocka eller svarar på frågor om frakt, retur och garanti.',
    placeholder:  'Skriv ett meddelande...',
    ariaOpen:     'Öppna Kronura AI-chatt',
    ariaClose:    'Stäng chatt',
    ariaInput:    'Skriv ett meddelande',
    statusText:   'Svarar direkt',
    headerName:   'Kronura AI',
    errGeneral:   'Något gick fel. Försök igen.',
    errLimit:     'För många förfrågningar. Försök igen om en stund.',
    errTimeout:   'Svaret tog för lång tid. Försök igen.',
    contactMsg:   'Du kan nå oss på support@kronura.se. Vi svarar normalt inom 12 timmar.',
    needsHuman:   'Vill du skicka detta till kundtjänst?',
    contactBtn:   'Kontakta kundtjänst',
    backBtn:      '← Tillbaka till alternativen',
    quick: [
      { label: 'Hjälp mig välja klocka', contact: false, guide: true },
      { label: 'Frakt & leverans',       contact: false, shortMsg: 'Fri frakt till hela Sverige. Leveranstiden är normalt 1–5 arbetsdagar beroende på modell och lager. Du får ett spårningsmail så fort paketet är på väg.' },
      { label: 'Retur & öppet köp',      contact: false, link: '/pages/oppet-kop-returer', linkLabel: 'Läs mer om retur & öppet köp', shortMsg: 'Du har öppet köp och kan returnera din beställning. Läs om våra returvillkor och hur du går till väga på retursidan.', secondary: { url: 'https://account.kronura.se', label: 'Ångra köp här' } },
      { label: 'Garanti',                contact: false, link: '/pages/garanti',            linkLabel: 'Läs mer om garanti',           shortMsg: 'Alla våra klockor har minst 2 års officiell tillverkargaranti. Garantin gäller tillverkningsfel vid normalt användande och hanteras av tillverkaren eller ett auktoriserat servicecenter.' },
      { label: 'Betalningsalternativ',   contact: false, shortMsg: 'Vi erbjuder trygga betalningsalternativ för alla behov. Betala enkelt med Klarna — välj faktura eller dela upp köpet i bekväma månadsbetalningar. Vi tar även emot Visa, Mastercard, Maestro, Apple Pay och Google Pay. Alla köp är krypterade och säkra.' },
      { label: 'Äkta klockor',           contact: false, shortMsg: 'Hos Kronura handlar du alltid äkta märkesklockor. Vi köper direkt från auktoriserade leverantörer — du behöver aldrig oroa dig för kopior eller oseriösa produkter. Originaldokumentation och garantibevis medföljer alltid.' },
      { label: 'Kontakta kundtjänst',    contact: false, link: '/pages/skriv-till-oss',    linkLabel: 'Skriv till oss',               shortMsg: 'Vi hjälper dig gärna! Fyll i kontaktformuläret så svarar vi normalt inom 12 timmar.' },
    ],
  };

  var COM = {
    welcome:      "Hi! I'm Kronura's assistant. I can help you with shipping, returns, and warranty questions.",
    placeholder:  'Type a message...',
    ariaOpen:     'Open Kronura AI chat',
    ariaClose:    'Close chat',
    ariaInput:    'Type a message',
    statusText:   'Replies instantly',
    headerName:   'Kronura AI',
    errGeneral:   'Something went wrong. Please try again.',
    errLimit:     'Too many requests. Please try again in a moment.',
    errTimeout:   'The response took too long. Please try again.',
    contactMsg:   'You can reach us at support@kronura.se. We typically respond within 1–2 business days.',
    needsHuman:   'Would you like to reach our customer service?',
    contactBtn:   'Contact support',
    backBtn:      '← Back to options',
    quick: [
      { label: 'Shipping & delivery', contact: false },
      { label: 'Returns',             contact: false, shortMsg: 'We offer 30-day returns from the date of delivery. The item must be unused and in original condition, with all packaging and accessories included. A return fee of 100 SEK applies.', secondary: { url: 'https://account.kronura.se', label: 'Withdraw from purchase' } },
      { label: 'Warranty',            contact: false },
      { label: 'Contact support',     contact: true  },
    ],
  };

  var STR = IS_COM ? COM : SE;

  // ── Constants ────────────────────────────────────────────────
  var STORAGE_KEY = 'kc_chat_v1';
  var SESSION_KEY = 'kc_sid';
  var STORAGE_TTL = 7 * 24 * 60 * 60 * 1000; // 7 dagar

  // ── Session ID ───────────────────────────────────────────────
  function genSessionId() {
    if (typeof crypto !== 'undefined' && crypto.randomUUID) return crypto.randomUUID();
    return Date.now().toString(36) + Math.random().toString(36).slice(2);
  }
  var sessionId;
  try {
    sessionId = localStorage.getItem(SESSION_KEY) || genSessionId();
    localStorage.setItem(SESSION_KEY, sessionId);
  } catch(e) { sessionId = genSessionId(); }

  // ── State ────────────────────────────────────────────────────
  var isOpen        = false;
  var isLoading     = false;
  var quickHidden   = false;
  var hasOpened     = false;
  var hasInteracted = false;
  var preferences   = {};
  var chatHistory   = [];
  var isReplaying   = false;
  var tooltipEl     = null;
  var tooltipTimer  = null;

  // ── Storage ──────────────────────────────────────────────────
  function saveToStorage() {
    if (!hasInteracted) return;
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify({
        history:     chatHistory,
        preferences: preferences,
        savedAt:     Date.now(),
      }));
    } catch(e) {}
  }

  function loadFromStorage() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return null;
      var data = JSON.parse(raw);
      if (!data || !data.savedAt) return null;
      if (Date.now() - data.savedAt > STORAGE_TTL) {
        localStorage.removeItem(STORAGE_KEY);
        return null;
      }
      return data;
    } catch(e) { return null; }
  }

  function clearStorage() {
    try { localStorage.removeItem(STORAGE_KEY); } catch(e) {}
  }

  // ── DOM-refs ─────────────────────────────────────────────────
  var rootEl    = document.getElementById('kc-root');
  var bubbleEl  = document.getElementById('kc-bubble');
  var windowEl  = document.getElementById('kc-window');
  var closeEl   = document.getElementById('kc-close');
  var messagesEl = document.getElementById('kc-messages');
  var inputEl   = document.getElementById('kc-input');
  var sendEl    = document.getElementById('kc-send');
  var statusEl  = document.getElementById('kc-status');

  if (!bubbleEl || !windowEl || !messagesEl || !inputEl || !sendEl) {
    console.warn('[Kronura Chat] DOM-element saknas. Kontrollera kronura-chat.liquid.');
    return;
  }

  // Markera att JS initierat korrekt — avdöljer bubblan
  if (rootEl) rootEl.classList.add('kc-ready');

  // ── Tooltip-bubbla bredvid chat-knappen ─────────────────────
  tooltipEl = document.createElement('div');
  tooltipEl.className = 'kc-tooltip';
  tooltipEl.setAttribute('aria-hidden', 'true');
  tooltipEl.textContent = IS_COM ? 'Any questions?' : 'Undrar du något?';
  if (rootEl) rootEl.appendChild(tooltipEl);

  tooltipTimer = setTimeout(function () {
    tooltipEl.classList.add('kc-tooltip--hidden');
  }, 6000);

  // ── Ladda sparad chatt från localStorage ─────────────────────
  (function initFromStorage() {
    var stored = loadFromStorage();
    if (!stored || !stored.history || !stored.history.length) return;
    preferences = stored.preferences || {};
    chatHistory  = stored.history;
    hasOpened    = true;
    isReplaying  = true;
    stored.history.forEach(function (msg) {
      if      (msg.type === 'bot')      addBotMessage(msg.text, false);
      else if (msg.type === 'user')     addUserMessage(msg.text);
      else if (msg.type === 'products') showProductCards(msg.products);
      else if (msg.type === 'link')     showMessageWithLink(msg.text, msg.url, msg.urlLabel, msg.secondary);
    });
    isReplaying = false;
    hasInteracted = true;
    addClearButton();
  }());

  // ── Init: tillämpa i18n-strängar ─────────────────────────────
  inputEl.placeholder = STR.placeholder;
  inputEl.setAttribute('aria-label', STR.ariaInput);
  bubbleEl.setAttribute('aria-label', STR.ariaOpen);
  if (closeEl) closeEl.setAttribute('aria-label', STR.ariaClose);
  if (statusEl) statusEl.textContent = STR.statusText;

  // ════════════════════════════════════════════════════════════
  // ÖPPNA / STÄNG
  // ════════════════════════════════════════════════════════════
  function open() {
    isOpen = true;
    windowEl.classList.add('kc-open');
    bubbleEl.setAttribute('aria-expanded', 'true');
    bubbleEl.classList.add('kc-bubble--open');

    if (tooltipEl) {
      clearTimeout(tooltipTimer);
      tooltipEl.classList.add('kc-tooltip--hidden');
    }

    if (!hasOpened) {
      hasOpened = true;
      showWelcome();
    }

    scrollToBottom();
    inputEl.focus();
    kcTrack('kc_chat_open');
  }

  function close() {
    isOpen = false;
    windowEl.classList.remove('kc-open');
    bubbleEl.setAttribute('aria-expanded', 'false');
    bubbleEl.classList.remove('kc-bubble--open');
    // Fokus tillbaka till bubblan för tillgänglighet
    bubbleEl.focus();
    kcTrack('kc_chat_close');
  }

  // ════════════════════════════════════════════════════════════
  // VÄLKOMST + SNABBKNAPPAR
  // ════════════════════════════════════════════════════════════
  function showWelcome() {
    addBotMessage(STR.welcome, false);
    if (!IS_COM) addGdprNotice();
    renderQuickButtons();
  }

  function addGdprNotice() {
    var row = document.createElement('div');
    row.className = 'kc-msg kc-msg--bot';
    var bubble = document.createElement('div');
    bubble.className = 'kc-msg__bubble kc-msg__bubble--gdpr';
    bubble.textContent = 'Konversationer sparas lokalt i din webbläsare i 7 dagar.';
    row.appendChild(bubble);
    messagesEl.appendChild(row);
  }

  function addClearButton() {
    if (document.getElementById('kc-clear')) return;
    var headerEl = windowEl ? windowEl.querySelector('.kc-header') : null;
    if (!headerEl) return;
    var btn = document.createElement('button');
    btn.id = 'kc-clear';
    btn.type = 'button';
    btn.className = 'kc-clear-btn';
    btn.textContent = IS_COM ? 'New chat' : 'Ny chatt';
    btn.setAttribute('aria-label', IS_COM ? 'Start new chat' : 'Starta ny chatt');
    btn.addEventListener('click', function () { resetChat(); });
    if (closeEl && closeEl.parentNode === headerEl) {
      headerEl.insertBefore(btn, closeEl);
    } else {
      headerEl.appendChild(btn);
    }
  }

  function resetChat() {
    clearStorage();
    chatHistory = [];
    messagesEl.innerHTML = '';
    quickHidden = false;
    hasInteracted = false;
    preferences = {};
    sessionId = genSessionId();
    try { localStorage.setItem(SESSION_KEY, sessionId); } catch(e) {}
    var clearBtn = document.getElementById('kc-clear');
    if (clearBtn) clearBtn.remove();
    showWelcome();
    scrollToBottom();
  }

  function renderQuickButtons() {
    if (quickHidden) return;

    var wrap = document.createElement('div');
    wrap.className = 'kc-quickbtns';
    wrap.id = 'kc-quickbtns';

    STR.quick.forEach(function (item, i) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'kc-quickbtn' + (i === STR.quick.length - 1 ? ' kc-quickbtn--wide' : '');
      btn.textContent = item.label;
      btn.addEventListener('click', function () {
        onQuickClick(item);
      });
      wrap.appendChild(btn);
    });

    messagesEl.appendChild(wrap);
    scrollToBottom();
  }

  // ════════════════════════════════════════════════════════════
  // GUIDED WATCH FINDER — kön → budget → produkter
  // ════════════════════════════════════════════════════════════
  function startWatchGuide() {
    var genderOptions = [
      { label: 'Herr',   value: 'herr' },
      { label: 'Dam',    value: 'dam'  },
      { label: 'Unisex', value: null   },
    ];
    showStepButtons('Vem handlar du för?', genderOptions, 3, function (opt) {
      addUserMessage(opt.label);
      preferences = Object.assign({}, preferences, { recipient: opt.value });
      showBudgetStep();
    });
  }

  function showBudgetStep() {
    var budgetOptions = [
      { label: 'Under 1 000 kr',  min: 0,    max: 999   },
      { label: '1 000–2 000 kr',  min: 1000, max: 2000  },
      { label: '2 000–3 000 kr',  min: 2000, max: 3000  },
      { label: 'Över 3 000 kr',   min: 3000, max: 50000 },
    ];
    showStepButtons('Vilken budget tänker du på?', budgetOptions, 2, function (opt) {
      addUserMessage(opt.label);
      preferences = Object.assign({}, preferences, { priceRange: { min: opt.min, max: opt.max } });

      var parts = [];
      if (preferences.recipient === 'herr') parts.push('herrur');
      else if (preferences.recipient === 'dam') parts.push('damur');
      else parts.push('klocka');

      if (opt.min === 0) {
        parts.push('under ' + opt.max + ' kr');
      } else if (opt.max < 50000) {
        parts.push(opt.min + '-' + opt.max + ' kr');
      } else {
        parts.push('över 3000 kr premium');
      }

      doSend(parts.join(' '));
    });
  }

  function showStepButtons(question, options, cols, onSelect) {
    addBotMessage(question, true);

    var wrap = document.createElement('div');
    wrap.className = 'kc-stepbtns kc-stepbtns--' + cols + 'col';

    options.forEach(function (opt) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'kc-quickbtn';
      btn.textContent = opt.label;
      btn.addEventListener('click', function () {
        wrap.remove();
        onSelect(opt);
      });
      wrap.appendChild(btn);
    });

    messagesEl.appendChild(wrap);
    scrollToBottom();
  }

  function hideQuickButtons() {
    if (quickHidden) return;
    quickHidden = true;
    var el = document.getElementById('kc-quickbtns');
    if (el) el.remove();
  }

  function onQuickClick(item) {
    kcTrack('kc_quick_reply', { label: item.label });
    hideQuickButtons();

    if (item.guide) {
      addUserMessage(item.label);
      startWatchGuide();
      return;
    }

    if (item.contact) {
      // Phase 3: ersätts med showSupportForm()
      showContactPlaceholder();
      return;
    }

    if (item.shortMsg) {
      addUserMessage(item.label);
      showMessageWithLink(item.shortMsg, item.link || null, item.linkLabel || null, item.secondary || null);
      return;
    }

    addUserMessage(item.label);
    doSend(item.label);
  }

  function showMessageWithLink(text, url, linkLabel, secondary) {
    var row = document.createElement('div');
    row.className = 'kc-msg kc-msg--bot kc-msg--new';

    var bubble = document.createElement('div');
    bubble.className = 'kc-msg__bubble';

    var p = document.createElement('p');
    p.className = 'kc-msg__text';
    p.textContent = text;
    bubble.appendChild(p);

    if (url && linkLabel) {
      var link = document.createElement('a');
      link.href = url;
      link.className = 'kc-escalate-btn';
      link.textContent = linkLabel;
      link.style.textDecoration = 'none';
      bubble.appendChild(link);
    }

    // Lagstadgad ångerfunktion (EU 2023/2673) — knapp till självbetjäningen
    if (secondary && secondary.url && secondary.label) {
      var angra = document.createElement('a');
      angra.href = secondary.url;
      angra.className = 'kc-escalate-btn';
      angra.textContent = secondary.label;
      angra.style.textDecoration = 'none';
      bubble.appendChild(angra);
      kcTrack('kc_anger_link_shown', { url: secondary.url });
    }

    var backBtn = document.createElement('button');
    backBtn.type = 'button';
    backBtn.className = 'kc-back-btn';
    backBtn.textContent = STR.backBtn;
    backBtn.addEventListener('click', function () {
      resetChat();
    });
    bubble.appendChild(backBtn);

    row.appendChild(bubble);
    messagesEl.appendChild(row);
    scrollToBottom();
    kcTrack('kc_page_link_shown', { url: url });

    if (!isReplaying) {
      chatHistory.push({ type: 'link', text: text, url: url || null, urlLabel: linkLabel || null, secondary: secondary || null });
      saveToStorage();
    }
  }

  // ════════════════════════════════════════════════════════════
  // MEDDELANDEN
  // ════════════════════════════════════════════════════════════
  function addBotMessage(text, animate, noSave) {
    var doAnimate = animate !== false;
    var row = document.createElement('div');
    row.className = 'kc-msg kc-msg--bot' + (doAnimate ? ' kc-msg--new' : '');

    var bubble = document.createElement('div');
    bubble.className = 'kc-msg__bubble';
    bubble.textContent = text;

    row.appendChild(bubble);

    // Visa feedback-knappar på nya live-svar (inte vid historik-replay)
    if (doAnimate && !isReplaying && !noSave && !IS_COM) {
      var fbWrap = document.createElement('div');
      fbWrap.className = 'kc-feedback';

      ['up', 'down'].forEach(function(vote) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'kc-feedback__btn';
        btn.textContent = vote === 'up' ? '👍' : '👎';
        btn.title = vote === 'up' ? 'Bra svar' : 'Dåligt svar';
        btn.addEventListener('click', function() {
          fbWrap.textContent = 'Tack!';
          fbWrap.className = 'kc-feedback kc-feedback--done';
          fetch(apiBase + '/api/chat/feedback', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ sid: sessionId, vote: vote }),
          }).catch(function() {});
        });
        fbWrap.appendChild(btn);
      });

      row.appendChild(fbWrap);
    }

    messagesEl.appendChild(row);
    scrollToBottom();

    if (!isReplaying && !noSave) {
      chatHistory.push({ type: 'bot', text: text });
      saveToStorage();
    }
  }

  function addUserMessage(text) {
    hasInteracted = true;
    var row = document.createElement('div');
    row.className = 'kc-msg kc-msg--user kc-msg--new';

    var bubble = document.createElement('div');
    bubble.className = 'kc-msg__bubble';
    bubble.textContent = text;

    row.appendChild(bubble);
    messagesEl.appendChild(row);
    scrollToBottom();

    if (!isReplaying) {
      chatHistory.push({ type: 'user', text: text });
      saveToStorage();
    }
  }

  function addErrorMessage(text) {
    var row = document.createElement('div');
    row.className = 'kc-msg kc-msg--error kc-msg--full kc-msg--new';

    var bubble = document.createElement('div');
    bubble.className = 'kc-msg__bubble';
    bubble.textContent = text;

    row.appendChild(bubble);
    messagesEl.appendChild(row);
    scrollToBottom();
  }

  function showTyping() {
    var row = document.createElement('div');
    row.className = 'kc-msg kc-msg--bot';
    row.id = 'kc-typing';
    row.innerHTML = '<div class="kc-msg__bubble kc-typing"><span></span><span></span><span></span></div>';
    messagesEl.appendChild(row);
    scrollToBottom();
  }

  function hideTyping() {
    var el = document.getElementById('kc-typing');
    if (el) el.remove();
  }

  // Phase 1: enkel kontaktinfo. Phase 3: ersätts med showSupportForm().
  function showContactPlaceholder() {
    var row = document.createElement('div');
    row.className = 'kc-msg kc-msg--bot kc-msg--new';

    var bubble = document.createElement('div');
    bubble.className = 'kc-msg__bubble';
    bubble.textContent = STR.contactMsg;

    row.appendChild(bubble);
    messagesEl.appendChild(row);
    scrollToBottom();
    kcTrack('kc_support_form_open', { trigger: 'manual' });
  }

  function showNeedsHuman() {
    var row = document.createElement('div');
    row.className = 'kc-msg kc-msg--bot kc-msg--new';

    var bubble = document.createElement('div');
    bubble.className = 'kc-msg__bubble';

    var text = document.createElement('p');
    text.className = 'kc-msg__text';
    text.textContent = STR.needsHuman;

    // Phase 3: ersätts med showSupportForm() inuti bubblan
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'kc-escalate-btn';
    btn.textContent = STR.contactBtn;
    btn.addEventListener('click', function () {
      kcTrack('kc_support_form_open', { trigger: 'needsHuman' });
      showContactPlaceholder();
      btn.disabled = true;
    });

    bubble.appendChild(text);
    bubble.appendChild(btn);
    row.appendChild(bubble);
    messagesEl.appendChild(row);
    scrollToBottom();
  }

  // ════════════════════════════════════════════════════════════
  // PRODUKTKORT (Phase 2)
  // ════════════════════════════════════════════════════════════
  function formatPrice(price, currency) {
    var n = Math.round(Number(price));
    if (!n) return null;
    return (currency === 'SEK' || !currency) ? n + ' kr' : n + ' ' + currency;
  }

  function makeFallbackIcon() {
    var el = document.createElement('div');
    el.className = 'kc-product-card__img-fallback';
    el.setAttribute('aria-hidden', 'true');
    el.innerHTML = '<svg width="32" height="32" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="11" cy="11" r="9.5" stroke="currentColor" stroke-width="1.5"/><path d="M11 7v4l2.8 2.8" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    return el;
  }

  function buildProductCard(product) {
    var card = document.createElement('div');
    card.className = 'kc-product-card';

    var imgWrap = document.createElement('div');
    imgWrap.className = 'kc-product-card__img-wrap';
    if (product.image) {
      var img = document.createElement('img');
      img.className = 'kc-product-card__img';
      img.src = product.image;
      img.alt = product.title || '';
      img.loading = 'lazy';
      img.onerror = function () {
        imgWrap.innerHTML = '';
        imgWrap.appendChild(makeFallbackIcon());
      };
      imgWrap.appendChild(img);
    } else {
      imgWrap.appendChild(makeFallbackIcon());
    }
    card.appendChild(imgWrap);

    var body = document.createElement('div');
    body.className = 'kc-product-card__body';

    if (product.vendor) {
      var vendor = document.createElement('span');
      vendor.className = 'kc-product-card__vendor';
      vendor.textContent = product.vendor;
      body.appendChild(vendor);
    }

    var title = document.createElement('p');
    title.className = 'kc-product-card__title';
    title.textContent = product.title || '';
    body.appendChild(title);

    var priceStr   = formatPrice(product.price, product.currency);
    var compareStr = formatPrice(product.compareAtPrice, product.currency);
    if (priceStr) {
      var priceWrap = document.createElement('div');
      priceWrap.className = 'kc-product-card__price-wrap';

      var priceEl = document.createElement('span');
      priceEl.className = 'kc-product-card__price';
      priceEl.textContent = priceStr;
      priceWrap.appendChild(priceEl);

      if (compareStr && Number(product.compareAtPrice) > Number(product.price)) {
        var compareEl = document.createElement('span');
        compareEl.className = 'kc-product-card__compare';
        compareEl.textContent = compareStr;
        priceWrap.appendChild(compareEl);
      }
      body.appendChild(priceWrap);
    }

    if (product.url) {
      var cta = document.createElement('a');
      cta.className = 'kc-product-card__cta';
      cta.href = product.url;
      cta.textContent = IS_COM ? 'View watch' : 'Visa klockan';
      body.appendChild(cta);
    }

    card.appendChild(body);
    return card;
  }

  function showProductCards(products) {
    if (!Array.isArray(products) || !products.length) return;
    showProductBatch(products, 0);
  }

  function showProductBatch(products, startIndex) {
    var batch = products.slice(startIndex, startIndex + 2);
    if (!batch.length) return;

    var wrap = document.createElement('div');
    wrap.className = 'kc-products' + (startIndex === 0 ? ' kc-msg--new' : '');
    batch.forEach(function (product) {
      wrap.appendChild(buildProductCard(product));
    });
    messagesEl.appendChild(wrap);
    scrollToBottom();

    var nextIndex = startIndex + 2;
    if (nextIndex < products.length) {
      var moreBtn = document.createElement('button');
      moreBtn.type = 'button';
      moreBtn.className = 'kc-more-btn';
      moreBtn.textContent = IS_COM ? 'Show more' : 'Visa fler alternativ';
      moreBtn.addEventListener('click', function () {
        moreBtn.remove();
        showProductBatch(products, nextIndex);
      });
      messagesEl.appendChild(moreBtn);
      scrollToBottom();
    }
  }

  // ════════════════════════════════════════════════════════════
  // API
  // ════════════════════════════════════════════════════════════
  function doSend(text) {
    if (isLoading) return;
    isLoading = true;
    setInputState(false);
    showTyping();

    var controller = typeof AbortController !== 'undefined' ? new AbortController() : null;
    var timeoutId = setTimeout(function () {
      if (controller) controller.abort();
    }, TIMEOUT_MS);

    var fetchOpts = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ message: text, preferences: preferences, sessionId: sessionId }),
    };
    if (controller) fetchOpts.signal = controller.signal;

    fetch(apiBase + '/api/chat', fetchOpts)
      .then(function (res) {
        clearTimeout(timeoutId);

        if (res.status === 429) {
          hideTyping();
          addErrorMessage(STR.errLimit);
          kcTrack('kc_rate_limit');
          return null;
        }

        if (!res.ok) {
          hideTyping();
          addErrorMessage(STR.errGeneral);
          kcTrack('kc_error', { status_code: res.status });
          return null;
        }

        return res.json();
      })
      .then(function (data) {
        if (!data) return;
        hideTyping();

        if (data.error) {
          addErrorMessage(data.error);
          return;
        }

        if (data.preferences) {
          preferences = Object.assign({}, preferences, data.preferences);
        }

        if (data.reply) {
          addBotMessage(data.reply, true);
        }

        if (data.needsHuman) {
          showNeedsHuman();
        }

        if (data.showProducts && Array.isArray(data.products) && data.products.length) {
          var slim = data.products.map(function(p) {
            return { title: p.title, vendor: p.vendor, price: p.price, compareAtPrice: p.compareAtPrice, currency: p.currency, image: p.image, url: p.url };
          });
          chatHistory.push({ type: 'products', products: slim });
          saveToStorage();
          showProductCards(data.products);
        }
      })
      .catch(function (err) {
        clearTimeout(timeoutId);
        hideTyping();
        if (err && err.name === 'AbortError') {
          addErrorMessage(STR.errTimeout);
        } else {
          addErrorMessage(STR.errGeneral);
          kcTrack('kc_error', { status_code: 0 });
        }
      })
      .finally(function () {
        isLoading = false;
        setInputState(true);
        if (isOpen) inputEl.focus();
      });
  }

  // ════════════════════════════════════════════════════════════
  // INPUT
  // ════════════════════════════════════════════════════════════
  function setInputState(enabled) {
    inputEl.disabled = !enabled;
    sendEl.disabled  = !enabled;
    if (enabled) {
      sendEl.classList.remove('kc-send--loading');
    } else {
      sendEl.classList.add('kc-send--loading');
    }
  }

  function onSend() {
    var text = inputEl.value.trim();
    if (!text || isLoading) return;

    hideQuickButtons();
    addUserMessage(text);
    inputEl.value = '';
    autoResize();

    kcTrack('kc_message_sent', { message_length: text.length });
    doSend(text);
  }

  function autoResize() {
    inputEl.style.height = 'auto';
    inputEl.style.height = Math.min(inputEl.scrollHeight, 110) + 'px';
  }

  // ── iPhone-tangentbord: scrolla input synlig ─────────────────
  inputEl.addEventListener('focus', function () {
    setTimeout(function () {
      inputEl.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
    }, 300);
  });

  // ════════════════════════════════════════════════════════════
  // SCROLL
  // ════════════════════════════════════════════════════════════
  function scrollToBottom() {
    requestAnimationFrame(function () {
      messagesEl.scrollTop = messagesEl.scrollHeight;
    });
  }

  // ════════════════════════════════════════════════════════════
  // EVENT LISTENERS
  // ════════════════════════════════════════════════════════════
  bubbleEl.addEventListener('click', function () {
    if (isOpen) { close(); } else { open(); }
  });

  if (closeEl) {
    closeEl.addEventListener('click', close);
  }

  sendEl.addEventListener('click', onSend);

  inputEl.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      onSend();
    }
  });

  inputEl.addEventListener('input', autoResize);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && isOpen) close();
  });

  // ════════════════════════════════════════════════════════════
  // TRACKING (GA4-redo, inga API-anrop)
  // ════════════════════════════════════════════════════════════
  function kcTrack(event, params) {
    if (typeof window.gtag === 'function') {
      window.gtag('event', event, params || {});
    }
    window.dispatchEvent(
      new CustomEvent('kc_event', { detail: Object.assign({ event: event }, params || {}) })
    );
  }

})();
